import React, { useState, useRef } from "react";
import Select, { components } from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import { post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { Toast } from "../../../Component/Toast";
import SubmitButton from "../../../Component/SubmitButton";
import CommonPopup from "../../../Component/CommonPopup";

const DeleteData = () => {
  const selectRef = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);

  /** FINAL VALUE (INPUT DISPLAY) */
  const [selected, setSelected] = useState([]);

  /** TEMP VALUE (CHECKBOX STATE WHILE MENU IS OPEN) */
  const [tempSelected, setTempSelected] = useState([]);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const options = [
    { value: "Sales", label: "Sales Report" },
    { value: "Recharges", label: "Recharge History" },
    { value: "Withdraws", label: "Withdraw History" },
    { value: "Commissions", label: "Commission History" },
    { value: "Wallet Transactions", label: "Wallet Transactions" },
  ];

  const styles = {
    control: (base) => ({
      ...base,
      minHeight: 50,
      borderRadius: 8,
      backgroundColor: "#F0EDE6",
      border: "1px solid #8F0D3dCC",
      boxShadow: "none",
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
      marginTop: 4,
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      backgroundColor: "#F0EDE6",
      padding: 0,
      borderRadius: 8,
    }),

    option: () => ({
      padding: 0,
      borderRadius: 8,
    }),

    // Style the selected tags (MultiValue)
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#8F0D3d22",
      borderRadius: 4,
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#8F0D3d",
      fontWeight: 500,
    }),

    // The × remove button on each tag
    multiValueRemove: (base) => ({
      ...base,
      color: "#8F0D3d",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#8F0D3d",
        color: "#fff",
        borderRadius: "0 4px 4px 0",
      },
    }),

    indicatorSeparator: () => ({ display: "none" }),
  };

  /* ---------- CHECKBOX OPTION ---------- */
  const CheckboxOption = ({ data, innerRef }) => {
    // Use tempSelected when menu is open, selected otherwise
    const activeList = menuOpen ? tempSelected : selected;
    const isChecked = activeList.some((x) => x.value === data.value);

    return (
      <div
        ref={innerRef}
        onClick={(e) => {
          e.stopPropagation();
          setTempSelected((prev) =>
            prev.some((x) => x.value === data.value)
              ? prev.filter((x) => x.value !== data.value)
              : [...prev, data]
          );
        }}
        role="checkbox"
        aria-checked={isChecked}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 12px",
          cursor: "pointer",
          backgroundColor: isChecked ? "#8F0D3d35" : "#F0EDE6",
          color: "#8F0D3d",
        }}
      >
        <span
          style={{
            position: "relative",
            width: 16,
            height: 16,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #8F0D3d",
            borderRadius: 3,
            backgroundColor: isChecked ? "#8F0D3d" : "transparent",
            flex: "0 0 auto",
          }}
        >
          <input
            type="checkbox"
            checked={isChecked}
            readOnly
            tabIndex={-1}
            style={{
              position: "absolute",
              inset: 0,
              margin: 0,
              opacity: 0,
              pointerEvents: "none",
            }}
          />
          {isChecked && (
            <svg width="12" height="10" viewBox="0 0 12 10" aria-hidden="true">
              <path
                d="M1 5L4 8L11 1"
                stroke="#fff"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
        <span style={{ marginLeft: 10 }}>{data.label}</span>
      </div>
    );
  };

  /* ---------- MENU WITH OK ---------- */
  const Menu = (props) => (
  <components.Menu {...props}>
    {props.children}
    <div
      style={{
        padding: 10,
        borderTop: "1px solid #ddd",
        background: "#F0EDE6",
        borderRadius: 8,
      }}
    >
      <button
        className="add-button f3 w-100"
        style={{ color: "#fff" }}
        onMouseDown={(e) => {
          // Prevent the select from losing focus (blur) before onClick fires
          e.preventDefault();
        }}
        onTouchStart={(e) => {
          // Same fix for mobile touch events
          e.preventDefault();
          setSelected(tempSelected);   // Apply immediately on touch
          setMenuOpen(false);
        }}
        onClick={() => {
          setSelected(tempSelected);
          setMenuOpen(false);
        }}
      >
        OK
      </button>
    </div>
  </components.Menu>
);

  /* ---------- HANDLE × REMOVE FROM TAG ---------- */
  // Called when the user clicks × on an already-committed tag (menu is closed)
  const handleChange = (newValue) => {
    // newValue is the updated array after react-select removes the item
    setSelected(newValue || []);
    // Also keep tempSelected in sync so re-opening the menu reflects the removal
    setTempSelected(newValue || []);
  };

  const handleDelete = async () => {
    if (!fromDate || !toDate) return Toast("Select date range");
    if (!selected.length) return Toast("Select at least one type");

    setLoading(true);
    try {
      await post(URLS.DELETEDATA, {
        start_date: fromDate,
        end_date: toDate,
        types: selected.map((x) => x.value),
        delete_after_export: true,
      });
      Toast("Deleted successfully");
      setPopup(false);
    } catch {
      Toast("API Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashRightView">
      <div className="container_overall containers_list">

        {/* MULTI SELECT */}
        <div className="col-md-5 my-3">
          <Select
            ref={selectRef}
            options={options}
            isMulti
            menuIsOpen={menuOpen}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isSearchable={false}
            styles={styles}
            // Always show the committed `selected` as the visible tags.
            // While the menu is open we still show `selected` so tags are
            // visible; checkbox state is driven by `tempSelected` inside
            // CheckboxOption directly.
            value={selected}
            placeholder="Select"
            components={{ Option: CheckboxOption, Menu }}

            // ✅ This fires when the user clicks × on a tag — works now
            onChange={handleChange}

            onMenuOpen={() => {
              setTempSelected(selected); // seed temp with current committed values
              setMenuOpen(true);
            }}

            onMenuClose={() => {
              // User closed without pressing OK — discard temp changes
              setMenuOpen(false);
            }}
          />
        </div>

        <DateRange
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="my-4 col-md-5">
          <SubmitButton
            onClick={() => setPopup(true)}
            title="Delete"
            disabled={!selected.length || !fromDate || !toDate}
            isFormValid={!(selected.length && fromDate && toDate)}
          />
        </div>

        <CommonPopup
          isOpen={popup}
          message="Are you sure?"
          onClose={() => setPopup(false)}
          onConfirm={handleDelete}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default DeleteData;
